import PinyinToolbox from './PinyinToolbox';

export default PinyinToolbox;
